import { Link } from 'react-router-dom'
import { DateTime } from 'luxon'
import { Table } from '@components/Table'
import { ColumnType } from '@components/Table/interface'
import { EyeIcon } from '@components/Icons'
import { CampaignType } from '@models/promotionCampaign/CampaignType'
import { campaignTypeLabel } from '@interfaces/promotionCampaign/CampaignTypeEnum'
import { StatusBadge } from '../StatusBadge/StatusBadge'
import { CampaignTableProps } from './interface'

function formatDateTime(value: string) {
  return DateTime.fromISO(value, { zone: 'utc' })
    .setZone('Asia/Bangkok')
    .toFormat('dd/MM/yyyy HH:mm:ss')
}

export function CampaignTable({ data, isLoading }: CampaignTableProps) {
  const columns: ColumnType<CampaignType>[] = [
    {
      column: 'ID',
      accessor: 'id',
      cell: ({ value }) => <p className='leading-[1.8]'>{value}</p>,
      cellClassName: 'p-[10px] min-w-[60px] max-w-[60px]',
    },
    {
      column: 'ชื่อแคมเปญ',
      accessor: 'name',
      cell: ({ value }) => (
        <p className='leading-[1.8] line-clamp-1'>{value}</p>
      ),
      cellClassName: 'p-[10px] w-full',
    },
    {
      column: 'ประเภท',
      accessor: 'type',
      cell: ({ value }) => (
        <p className='leading-[1.8]'>
          {campaignTypeLabel[value as keyof typeof campaignTypeLabel] || value}
        </p>
      ),
      cellClassName: 'p-[10px] min-w-[130px] max-w-[130px]',
    },
    {
      column: 'สถานะ',
      accessor: 'status',
      cell: ({ value, obj }) => <StatusBadge status={value} />,
      cellClassName: 'p-[10px] min-w-[120px] max-w-[120px]',
    },
    {
      column: 'จำนวนหนังสือ',
      accessor: 'bookCount',
      cell: ({ value }) => <p className='leading-[1.8]'>{value}</p>,
      cellClassName: 'p-[10px] min-w-[100px] max-w-[100px]',
    },
    {
      column: 'เวลาสร้าง',
      accessor: 'createdAt',
      cell: ({ value }) => (
        <p className='leading-[1.8]'>{value ? formatDateTime(value) : '-'}</p>
      ),
      cellClassName: 'p-[10px] min-w-[160px] max-w-[160px]',
    },
    {
      column: 'เวลาอัปเดต',
      accessor: 'updatedAt',
      cell: ({ value }) => (
        <p className='leading-[1.8]'>{value ? formatDateTime(value) : '-'}</p>
      ),
      cellClassName: 'p-[10px] min-w-[160px] max-w-[160px]',
    },
    {
      column: 'Action',
      isAction: true,
      actionCell: ({ obj }) => (
        <Link to={`/promotion-campaign/${obj.id}`}>
          <button
            className='border border-gray w-[30px] h-[30px] rounded-[8px]'
            type='button'
          >
            <EyeIcon
              className='text-secondary-100 mx-auto'
              width='18'
              height='18'
            />
          </button>
        </Link>
      ),
      cellClassName: 'p-[10px] min-w-[60px] max-w-[60px]',
    },
  ]

  return <Table data={data || []} columns={columns} isLoading={isLoading} />
}
